/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PAYMENT_QUEUE } from "../graphql";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import moment from "moment";
import {
  AppServiceMachineType,
  AppServiceRequestProcessor,
} from "../../state-machine";
import { ProcessQResponseMessage } from "../messages";
import { PROCESS_PAYMENT_Q_RESPONSE } from "../machines/process-payment-q-response";
import { DEFAULT_APP_CONFIG } from "../../../config/default.config";
import { MqttService } from "../../../widgets/mqtt-v2-service-react";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();
const distCenterData = storageService.get("distCenterData", "local");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const eventBusModule = EventBusModule.getInstance();
const evBus = eventBusModule.getEventBus();

export interface IMqqtMethods extends IPluginMethodMap {
  mqttInit(args: any): Promise<any>;
}

export class MqqtService
  extends AppServiceRequestProcessor
  implements IAgentPlugin
{
  readonly methods: IMqqtMethods;
  private client?: any;
  private eventBus: any;

  constructor() {
    super();
    this.methods = {
      mqttInit: this.mqttInit.bind(this),
    };
    this.client = MqttService.getInstance({
      brokerURL: DEFAULT_APP_CONFIG?.mqttService?.MQTT_BROKER_URL,
      username: DEFAULT_APP_CONFIG?.mqttService?.MQTT_USERNAME,
      password: DEFAULT_APP_CONFIG?.mqttService?.MQTT_PASSWORD,
    });
    this.eventBus = this.client.getEventBus();
  }

  async mqttInit(args: any) {
    log.blue(`mqtt payload :`, args);
    //return {...(config)}
    console.log(`distCenterData in payment service`, distCenterData);
    try {
      this.eventBus.on("connect", () => {
        console.log("connected -----------------");
        this.client.subscribeTopics(args);
      });
      // this.client = await MqttService.getInstance({
      //   brokerURL: DEFAULT_APP_CONFIG?.mqttService?.MQTT_BROKER_URL,
      //   username: DEFAULT_APP_CONFIG?.mqttService?.MQTT_USERNAME,
      //   password: DEFAULT_APP_CONFIG?.mqttService?.MQTT_PASSWORD,
      // });
      // this.eventBus = this.client.getEventBus();
      // this.eventBus.on("connect", () => {
      //   console.log("connected -----------------");
      //   this.client.subscribeTopics(args);
      // });
      // this.eventBus.on("connect", this.eventHandler.bind(this, "connect"));
      // this.eventBus.on("closed", this.eventHandler.bind(this, "closed"));
      // this.eventBus.on("error", this.eventHandler.bind(this, "error"));
      await this.eventBus.on(
        "message",
        this.eventHandler.bind(this, "message")
      );
    } catch (e) {}
  }

  async eventHandler(event: string, msg?: any) {
    log.success(`[mqtt] event ${event}`, msg);
    if (event === "message") {
      try {
        let topic = msg?.topic;
        let data = await msg?.message;
        log.blue(`mqtt on any change in queue`, topic, data);
        if (data) {
          let farmatedMsg: any = this.preFarmatMessage(data?.jobs?.data);
          log.blue(`mqtt before sending to format`, farmatedMsg);
          const message = await this.processQResponseMachine(farmatedMsg);
          log.blue(`mqtt after sending to format`, message);
          if (message?.raw) {
            delete message.raw;
          }
          if (message?.isDataChanged) {
            evBus.emit("distributionQueue", this, message);
          }
        }
      } catch (e) {
        log.error(`Error in handleW3CMessage =>`, e);
      }
    }
  }

  private async processQResponseMachine(raw: any) {
    log.blue(`mqtt processQResponseMachine :`, raw);
    try {
      const machineType = AppServiceMachineType.PROCESS_PAYMENT_Q_RESPONSE;
      const message = new ProcessQResponseMessage({
        raw: raw,
      });
      await this.startProcessing({
        machineType: machineType,
        machineConfig: PROCESS_PAYMENT_Q_RESPONSE?.extendContextWith({
          message: message,
        }),
      });
      console.log("SM outputted message", message);
      return message;
    } catch (e: any) {
      log.error(`Error in handleW3CMessage =>`, e);
      throw e;
    }
  }

  private preFarmatMessage(data: any) {
    let formattedData: any = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        if (
          distCenterData?.paymentCounter === item?.data?.lockedByDistCounter
        ) {
          formattedData.push({
            ...item?.data,
          });
        }
      });
    return { parsed: formattedData };
  }
}
